import * as yup from 'yup';

export const useSchemaInvoiceGroup = () => {
  // OBS: alla typade fält är .nullable() — API:t (InvoiceGroup) returnerar null för osatta kolumner, och
  // yup .optional() tillåter bara undefined, INTE null. Utan .nullable() blir formuläret tyst ogiltigt och
  // handleSubmit anropar aldrig onSubmit (= "spara gör inget"). T.ex. swishRecurringAccount defaultar till null.
  const invoiceGroupSchema = yup.object().shape({
    // Swish
    swishAccount: yup.string().nullable().optional(),
    swishRecurringAccount: yup.string().nullable().optional(),
    swishData1: yup.string().nullable().optional(),
    swishActive: yup.string().oneOf(['0', '1']).nullable().optional(),

    // Stripe
    stripeAccount: yup.string().nullable().optional(),
    stripeActive: yup.string().oneOf(['0', '1']).nullable().optional(),

    // Bank
    accountNr: yup.string().nullable().optional(),
    accountType: yup.number().nullable().optional(),
    accountName: yup.string().nullable().optional(),
    iban: yup.string().nullable().optional(),
    bic: yup.string().nullable().optional(),

    // Autogiro
    autogiroCustomerNr: yup.string().nullable().optional(),
    autogiroAccount: yup.string().nullable().optional(),

    // Övriga betalmetodinställningar
    paymentMethod: yup.number().nullable().optional(),
    paymentMethodOrder: yup.string().nullable().optional(),
    pmSelectionHeader: yup.string().nullable().optional(),
    preSelect: yup.boolean().nullable().optional(),
    autoApprovePayments: yup.boolean().nullable().optional(),
    sharedAccount: yup.boolean().nullable().optional(),

    // Kortdata
    cardData1: yup.string().nullable().optional(),
    cardData2: yup.string().nullable().optional(),
    cardData3: yup.string().nullable().optional(),
    cardSupplier: yup.number().nullable().optional(),

    // Avgifter / avtal
    adminFee: yup.number().nullable().optional(),

    // E-faktura
    electronicInvoiceEmailNotification: yup.string().nullable().optional(),

    // Övriga metadata
    customerNr: yup.string().nullable().optional(),
    name: yup.string().nullable().optional(),
    owner_id: yup.number().nullable().optional(),
    localAssIds: yup.string().nullable().optional(),
    payerNumberIsBirthdate: yup.boolean().nullable().optional(),
    continueBtnText: yup.string().nullable().optional(),
    senderTitle: yup.string().nullable().optional(),
    template_id: yup.number().nullable().optional(),
    paymentMethods: yup.array().of(
      yup.object({
        type: yup.number().nullable().optional(),
        pos: yup.number().nullable().optional(),
        active: yup.mixed<'0' | '1'>().oneOf(['0', '1']).nullable().optional(),
        name: yup.string().nullable().optional(),
      }),
    ),
  });

  return invoiceGroupSchema;
};
